const testimonials = [
  {
    name: 'Adebayo Johnson',
    location: 'Lagos',
    rating: 5,
    text: 'I sold my car within 3 days on ListIt! The verification system made me feel safe, and the buyers were genuine. Highly recommended!',
    avatar: 'https://public.readdy.ai/ai/img_res/45e9eac50a87be03026fb818dac8cb22.jpg'
  },
  {
    name: 'Fatima Abdullahi',
    location: 'Abuja',
    rating: 5,
    text: 'Found the perfect apartment through ListIt. The chat feature made it easy to communicate with landlords, and the process was smooth.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Nigerian%20woman%20wearing%20hijab%2C%20warm%20smile%2C%20business%20attire%2C%20clean%20background%2C%20professional%20lighting%2C%20modern%20portrait%20photography%20style&width=80&height=80&seq=avatar2&orientation=squarish'
  },
  {
    name: 'Chinedu Okafor',
    location: 'Port Harcourt',
    rating: 5,
    text: 'As a small business owner, ListIt has been amazing for selling my electronics. The featured listing option really boosted my sales!',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Nigerian%20man%20with%20glasses%2C%20friendly%20smile%2C%20casual%20business%20attire%2C%20clean%20background%2C%20professional%20lighting%2C%20modern%20portrait%20photography%20style&width=80&height=80&seq=avatar3&orientation=squarish'
  }
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Users Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Real stories from real people who found success on ListIt
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-100">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-yellow-400 text-sm ${
                      i < testimonial.rating ? '' : 'text-gray-300'
                    }`}
                  ></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 italic">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500 flex items-center">
                    <i className="ri-map-pin-line mr-1"></i>
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}